import { AlertCircle, CheckCircle, Clock, XCircle, UserX, Lock, Calendar, Ban } from 'lucide-react';
import { ApartmentStatus } from '../types/building';

/**
 * Hintergrundfarben für verschiedene Status
 */
export const statusColors: Record<ApartmentStatus, string> = {
  pending: 'bg-red-50 hover:bg-red-100',
  in_progress: 'bg-yellow-50 hover:bg-yellow-100',
  completed: 'bg-green-50 hover:bg-green-100',
  completed_with_cable: 'bg-green-50 hover:bg-green-100',
  completed_no_measurement: 'bg-green-50 hover:bg-green-100',
  tenant_absent: 'bg-orange-50 hover:bg-orange-100',
  access_denied: 'bg-red-50 hover:bg-red-100',
  tenant_affected_no_access: 'bg-red-50 hover:bg-red-100',
  tenant_affected_with_cable: 'bg-orange-50 hover:bg-orange-100',
  present_no_access: 'bg-red-50 hover:bg-red-100',
  appointment_cancelled: 'bg-gray-50 hover:bg-gray-100',
  aborted: 'bg-purple-50 hover:bg-purple-100',
};

/**
 * Icons für verschiedene Status
 */
export const statusIcons = {
  pending: AlertCircle,
  in_progress: Clock,
  completed: CheckCircle,
  completed_with_cable: CheckCircle,
  completed_no_measurement: CheckCircle,
  tenant_absent: UserX,
  access_denied: Lock,
  tenant_affected_no_access: XCircle,
  tenant_affected_with_cable: XCircle,
  present_no_access: Lock,
  appointment_cancelled: Calendar,
  aborted: Ban,
};

/**
 * Deutsche Bezeichnungen für Status
 */
export const statusLabels: Record<ApartmentStatus, string> = {
  pending: 'Ausstehend',
  in_progress: 'In Bearbeitung',
  completed: '1',
  completed_with_cable: '1-K',
  completed_no_measurement: '10',
  tenant_absent: '2',
  access_denied: '3',
  tenant_affected_no_access: '4',
  tenant_affected_with_cable: '4-K',
  present_no_access: '5',
  appointment_cancelled: '6',
  aborted: 'Abbruch',
};